import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / Editor`}</p>
    <h1 {...{
      "id": "class-editor"
    }}>{`Class: Editor`}</h1>
    <p>{`Entry point for APIs that read or modify the document's content.`}</p>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><inlineCode parentName="p">{`ProxyLiveObject`}</inlineCode></p>
        <p parentName="li">{`↳ `}<strong parentName="p"><inlineCode parentName="strong">{`Editor`}</inlineCode></strong></p>
      </li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "accessors"
    }}>{`Accessors`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#context"
        }}>{`context`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#documentRoot"
        }}>{`documentRoot`}</a></li>
    </ul>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createColorFill"
        }}>{`createColorFill`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createEllipse"
        }}>{`createEllipse`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createGroup"
        }}>{`createGroup`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createImageContainer"
        }}>{`createImageContainer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createLine"
        }}>{`createLine`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createRectangle"
        }}>{`createRectangle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createStroke"
        }}>{`createStroke`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#createText"
        }}>{`createText`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Editor.md#loadBitmapImage"
        }}>{`loadBitmapImage`}</a></li>
    </ul>
    <h2 {...{
      "id": "accessors-1"
    }}>{`Accessors`}</h2>
    <h3 {...{
      "id": "a-idcontext-namecontexta-context"
    }}><a id="context" name="context"></a>{` context`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`context`}</strong>{`(): `}<a parentName="p" {...{
        "href": "Context.md"
      }}><inlineCode parentName="a">{`Context`}</inlineCode></a></p>
    <p>{`User's current selection context`}</p>
    <h4 {...{
      "id": "returns"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "Context.md"
      }}><inlineCode parentName="a">{`Context`}</inlineCode></a></p>
    <hr></hr>
    <h3 {...{
      "id": "a-iddocumentroot-namedocumentroota-documentroot"
    }}><a id="documentRoot" name="documentRoot"></a>{` documentRoot`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`documentRoot`}</strong>{`(): `}<a parentName="p" {...{
        "href": "ExpressRootNode.md"
      }}><inlineCode parentName="a">{`ExpressRootNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-1"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "ExpressRootNode.md"
      }}><inlineCode parentName="a">{`ExpressRootNode`}</inlineCode></a></p>
    <p>{`the root of the document.`}</p>
    <h2 {...{
      "id": "methods-1"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "a-idcreatecolorfill-namecreatecolorfilla-createcolorfill"
    }}><a id="createColorFill" name="createColorFill"></a>{` createColorFill`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createColorFill`}</strong>{`(`}<inlineCode parentName="p">{`color`}</inlineCode>{`): `}<a parentName="p" {...{
        "href": "../interfaces/ColorFill.md"
      }}><inlineCode parentName="a">{`ColorFill`}</inlineCode></a></p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`color`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "Color.md"
            }}><inlineCode parentName="a">{`Color`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The color to use for the fill.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-2"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "../interfaces/ColorFill.md"
      }}><inlineCode parentName="a">{`ColorFill`}</inlineCode></a></p>
    <p>{`a solid color fill.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreateellipse-namecreateellipsea-createellipse"
    }}><a id="createEllipse" name="createEllipse"></a>{` createEllipse`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createEllipse`}</strong>{`(): `}<a parentName="p" {...{
        "href": "EllipseNode.md"
      }}><inlineCode parentName="a">{`EllipseNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-3"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "EllipseNode.md"
      }}><inlineCode parentName="a">{`EllipseNode`}</inlineCode></a></p>
    <p>{`an ellipse node with default x/y radii, and `}<em parentName="p">{`no`}</em>{` initial stroke or fill.
Transform values default to 0.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreategroup-namecreategroupa-creategroup"
    }}><a id="createGroup" name="createGroup"></a>{` createGroup`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createGroup`}</strong>{`(): `}<a parentName="p" {...{
        "href": "GroupNode.md"
      }}><inlineCode parentName="a">{`GroupNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-4"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "GroupNode.md"
      }}><inlineCode parentName="a">{`GroupNode`}</inlineCode></a></p>
    <p>{`a group node.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreateimagecontainer-namecreateimagecontainera-createimagecontainer"
    }}><a id="createImageContainer" name="createImageContainer"></a>{` createImageContainer`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createImageContainer`}</strong>{`(`}<inlineCode parentName="p">{`bitmapData`}</inlineCode>{`, `}<inlineCode parentName="p">{`options?`}</inlineCode>{`): `}<a parentName="p" {...{
        "href": "MediaContainerNode.md"
      }}><inlineCode parentName="a">{`MediaContainerNode`}</inlineCode></a></p>
    <p>{`Creates a bitmap image, represented as a multi-node MediaContainerNode structure. Always creates a "full-frame,"
uncropped image initially, but cropping can be changed after it is created by modifying the properties of the
container's mediaRectangle and maskShape children.`}</p>
    <p>{`Image creation involves some asynchronous steps. The image will be visible in this client almost instantly, but will
render as a gray placeholder on other clients until it has been uploaded to storage and then downloaded by those clients.
This local client will act as having unsaved changes until the upload has finished.`}</p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bitmapData`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "../interfaces/BitmapImage.md"
            }}><inlineCode parentName="a">{`BitmapImage`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`BitmapImage resource (e.g. returned from loadBitmapImage()).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Additional configuration:`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options.initialSize?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "../interfaces/RectangleGeometry.md"
            }}><inlineCode parentName="a">{`RectangleGeometry`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Size the image is displayed at. Must have the same aspect ratio as bitmapData. Defaults to the        size the image would be created at by a UI drag-drop gesture (typically the image's full size, but scaled down        if needed to stay below an application-defined size cap).`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-5"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "MediaContainerNode.md"
      }}><inlineCode parentName="a">{`MediaContainerNode`}</inlineCode></a></p>
    <p>{`MediaContainerNode representing the top container node of the multi-node structure.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreateline-namecreatelinea-createline"
    }}><a id="createLine" name="createLine"></a>{` createLine`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createLine`}</strong>{`(): `}<a parentName="p" {...{
        "href": "LineNode.md"
      }}><inlineCode parentName="a">{`LineNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-6"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "LineNode.md"
      }}><inlineCode parentName="a">{`LineNode`}</inlineCode></a></p>
    <p>{`a line node with default start point and end point and a default stroke.
Transform values default to 0.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreaterectangle-namecreaterectanglea-createrectangle"
    }}><a id="createRectangle" name="createRectangle"></a>{` createRectangle`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createRectangle`}</strong>{`(): `}<a parentName="p" {...{
        "href": "RectangleNode.md"
      }}><inlineCode parentName="a">{`RectangleNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-7"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "RectangleNode.md"
      }}><inlineCode parentName="a">{`RectangleNode`}</inlineCode></a></p>
    <p>{`a rectangle node with default width and height, and `}<em parentName="p">{`no`}</em>{` initial stroke or fill.
Transform values default to 0.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreatestroke-namecreatestrokea-createstroke"
    }}><a id="createStroke" name="createStroke"></a>{` createStroke`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createStroke`}</strong>{`(`}<inlineCode parentName="p">{`options?`}</inlineCode>{`): `}<a parentName="p" {...{
        "href": "../interfaces/Stroke.md"
      }}><inlineCode parentName="a">{`Stroke`}</inlineCode></a></p>
    <p>{`See `}<a parentName="p" {...{
        "href": "../interfaces/StrokeOptions.md"
      }}>{`StrokeOptions`}</a>{` for more details on the `}<inlineCode parentName="p">{`options`}</inlineCode>{` fields. Defaults:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`color`}</inlineCode>{` has default value DEFAULT_STROKE_COLOR if none is provided.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`width`}</inlineCode>{` has default value DEFAULT_STROKE_WIDTH if none is provided.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`dashPattern`}</inlineCode>{` has default value [] if none is provided. If the dash pattern has
odd number of elements, the items are copied to double the array. For example,
`}{`[1, 2, 3]`}{` becomes `}{`[1, 2, 3, 1, 2, 3]`}{`. Values cannot be negative.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`dashOffset`}</inlineCode>{` has default value 0 if none is provided. This options field is ignored
if no `}<inlineCode parentName="li">{`dashPattern`}</inlineCode>{` was provided.`}</li>
    </ul>
    <p>{`The stroke's `}<inlineCode parentName="p">{`position`}</inlineCode>{` field cannot be specified via options yet because only
`}<a parentName="p" {...{
        "href": "../enums/StrokePositionValue.md#center"
      }}>{`center`}</a>{` is supported.`}</p>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`options?`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Partial`}</inlineCode>{`<`}<a parentName="td" {...{
              "href": "../interfaces/StrokeOptions.md"
            }}><inlineCode parentName="a">{`StrokeOptions`}</inlineCode></a>{`>`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-8"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "../interfaces/Stroke.md"
      }}><inlineCode parentName="a">{`Stroke`}</inlineCode></a></p>
    <p>{`a stroke configured with the given options.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idcreatetext-namecreatetexta-createtext"
    }}><a id="createText" name="createText"></a>{` createText`}</h3>
    <p>{`▸ `}<strong parentName="p">{`createText`}</strong>{`(): `}<a parentName="p" {...{
        "href": "TextNode.md"
      }}><inlineCode parentName="a">{`TextNode`}</inlineCode></a></p>
    <h4 {...{
      "id": "returns-9"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "TextNode.md"
      }}><inlineCode parentName="a">{`TextNode`}</inlineCode></a></p>
    <p>{`a text node with default styles. The text content is initially empty, so the text node will be
invisible until its `}<inlineCode parentName="p">{`text`}</inlineCode>{` property is set. Creates point text, so the node's width will automatically
adjust to accommodate whatever text is set.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idloadbitmapimage-nameloadbitmapimagea-loadbitmapimage"
    }}><a id="loadBitmapImage" name="loadBitmapImage"></a>{` loadBitmapImage`}</h3>
    <p>{`▸ `}<strong parentName="p">{`loadBitmapImage`}</strong>{`(`}<inlineCode parentName="p">{`bitmapData`}</inlineCode>{`): `}<inlineCode parentName="p">{`Promise`}</inlineCode>{`<`}<a parentName="p" {...{
        "href": "../interfaces/BitmapImage.md"
      }}><inlineCode parentName="a">{`BitmapImage`}</inlineCode></a>{`>`}</p>
    <p>{`Creates a bitmap image resource in the document, which can be displayed in the scenegraph by passing it to `}<a parentName="p" {...{
        "href": "Editor.md#createImageContainer"
      }}>{`createImageContainer`}</a>{`
to create a MediaContainerNode. The same BitmapImage can be used to create multiple MediaContainerNodes.`}</p>
    <p>{`Note: image resources that are unused will be automatically cleaned up after the document is closed.`}</p>
    <p>{`Async steps to upload image resource data continue in the background after this call's Promise resolves, but the BitmapImage
return value can be used immediately. The local client will act as having unsaved changes until the upload has finished.`}</p>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bitmapData`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Blob`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Encoded image data in PNG or JPEG format.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-10"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`Promise`}</inlineCode>{`<`}<a parentName="p" {...{
        "href": "../interfaces/BitmapImage.md"
      }}><inlineCode parentName="a">{`BitmapImage`}</inlineCode></a>{`>`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      